import { apiClient, WHOLE_USE_MOCK } from './api';
import { mockDataUtil } from './mockDataUtil';
import { accounts } from '../mock/mockAccountData.js'
import { API_ENDPOINTS } from '../utils/apiEndpoints';

class AccountService {
  /**
   * 获取账号列表
   */
  async getAccounts(params) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      let filteredAccounts = [...accounts];

      // 根据查询条件过滤
      if (params.loginId) {
        filteredAccounts = filteredAccounts.filter(account =>
            account.loginId.toLowerCase().includes(params.loginId.toLowerCase())
        );
      }

      if (params.nameLike) {
        filteredAccounts = filteredAccounts.filter(account =>
            account.name.includes(params.nameLike)
        );
      }

      const pageSize = params.pageSize || 10;
      const currentPage = params.currentPage || 1;
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const paginatedAccounts = filteredAccounts.slice(startIndex, endIndex);

      return mockDataUtil.mockPageRes(paginatedAccounts, {
        currentPage: currentPage,
        totalCount: filteredAccounts.length,  // 修复：使用过滤后的总数量而不是当前页的数量
        pageSize: pageSize
      });
    } else {
      return apiClient.post(API_ENDPOINTS.ACCOUNT.PAGE, params);
    }
  }

  /**
   * 创建账号
   */
  async createAccount(account) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const newAccount = {
        id: accounts.length + 2600,
        accountId: accounts.length + 2600,
        loginId: account.loginId,
        name: account.name,
        mobile: account.mobile || null,
        email: account.email || null,
        accountStatus: 1,
        jobStatus: 1,
        orgName: null,
        gmtCreateStr: new Date().toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).replace(/\//g, '-'),
        roleList: [],
        roleNameArr: []
      };

      accounts.push(newAccount);

      return mockDataUtil.mockRes({
        traceId: "64eed1ec3d564eccac6a74aa05c6e633",
        success: true,
        msg: null,
        errorCode: null,
        errorMessage: null,
        flag: "success",
        code: null,
        message: null,
        properties: {},
        data: newAccount
      });
    } else {
      return apiClient.post(API_ENDPOINTS.ACCOUNT.CREATE, account);
    }
  }

  /**
   * 更新账号
   */
  async updateAccount(account) {
    // 确保只发送API需要的字段
    const updateData = {
      loginId: account.loginId,
      name: account.name,
      email: account.email,
      mobile: account.mobile,
      orgName: account.orgName,
      orgCode: account.orgCode
    };

    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const index = accounts.findIndex(a => a.id === account.id || a.loginId === account.loginId);
      if (index === -1) {
        return mockDataUtil.mockCreateErrorRes("账号不存在");
      }

      // 更新账号信息
      const updatedAccount = {
        ...accounts[index],
        name: account.name,
        mobile: account.mobile || null,
        email: account.email || null
      };

      accounts[index] = updatedAccount;

      return {
        traceId: "64eed1ec3d564eccac6a74aa05c6e633",
        success: true,
        msg: null,
        errorCode: null,
        errorMessage: null,
        flag: "success",
        code: null,
        message: null,
        properties: {},
        data: updatedAccount
      };
    } else {
      return apiClient.post(API_ENDPOINTS.ACCOUNT.UPDATE, updateData);
    }
  }

  /**
   * 删除账号
   */
  async deleteAccount(loginId) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const index = accounts.findIndex(a => a.loginId === loginId);
      if (index === -1) {
        return mockDataUtil.mockRes("账号不存在");
      }

      accounts.splice(index, 1);

      return mockDataUtil.mockRes();
    } else {
      return apiClient.post(API_ENDPOINTS.ACCOUNT.DELETE, { loginId });
    }
  }

  /**
   * 修改密码
   */
  async changePassword(passwordData) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const { loginId, password, passwordEncryptType } = passwordData;

      // 检查账号是否存在
      const accountIndex = accounts.findIndex(a => a.loginId === loginId);
      if (accountIndex === -1) {
        return mockDataUtil.mockCreateErrorRes("账号不存在");
      }

      // 在实际应用中，这里会更新密码，但在mock中我们只需要返回成功
      return mockDataUtil.mockRes();
    } else {
      return apiClient.post(API_ENDPOINTS.ACCOUNT.CHANGE_PASSWORD, passwordData);
    }
  }

  /**
   * 获取账号的角色信息
   */
  async getAccountRoles(loginId) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const account = accounts.find(a => a.loginId === loginId);
      if (!account) {
        return mockDataUtil.mockCreateErrorRes("账号不存在");
      }

      return mockDataUtil.mockRes({
        loginId: account.loginId,
        roleCodes: account.roleList ? account.roleList.map(r => r.code) : []
      });
    } else {
      return apiClient.post(API_ENDPOINTS.ACCOUNT.GET_ROLES, { loginId });
    }
  }

  /**
   * 为账号分配角色
   */
  async assignRoles(roleData) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const { loginId, roleCodes } = roleData;

      console.log('开始分配角色:', { loginId, roleCodes });

      // 检查账号是否存在
      const accountIndex = accounts.findIndex(a => a.loginId === loginId);
      if (accountIndex === -1) {
        console.error('账号不存在:', loginId);
        return mockDataUtil.mockCreateErrorRes("账号不存在");
      }

      // 导入角色数据来获取角色名称
      const { roles } = await import('../mock/mockRoleData.js');
      
      // 模拟从角色数据中获取角色信息
      const assignedRoles = roleCodes.map(code => {
        const roleInfo = roles.find(r => r.code === code);
        return {
          code: code,
          name: roleInfo ? roleInfo.name : `角色_${code}`
        };
      });

      console.log('分配的角色:', assignedRoles);

      // 更新账号的角色信息
      accounts[accountIndex] = {
        ...accounts[accountIndex],
        roleList: assignedRoles,
        roleNameArr: assignedRoles.map(r => r.name)
      };

      console.log('更新后的账号:', accounts[accountIndex]);

      return mockDataUtil.mockRes({
        loginId: loginId,
        roleCodes: roleCodes,
        assignedRoles: assignedRoles
      });
    } else {
      const { roleCodes } = roleData;
      let req = {...roleData};
      req.roleCodeSet = roleCodes;
      return apiClient.post(API_ENDPOINTS.ACCOUNT.ASSIGN_ROLES, req);
    }
  }

  /**
   * 为账号移除角色
   */
  async removeRoles(roleData) {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      const { loginId, removeRoleCodeSet } = roleData;

      console.log('开始移除角色:', { loginId, removeRoleCodeSet });

      // 检查账号是否存在
      const accountIndex = accounts.findIndex(a => a.loginId === loginId);
      if (accountIndex === -1) {
        console.error('账号不存在:', loginId);
        return mockDataUtil.mockCreateErrorRes("账号不存在");
      }

      // 从账号的角色列表中移除指定的角色
      const updatedRoleList = accounts[accountIndex].roleList.filter(
        role => !removeRoleCodeSet.includes(role.code)
      );

      // 更新账号的角色信息
      accounts[accountIndex] = {
        ...accounts[accountIndex],
        roleList: updatedRoleList,
        roleNameArr: updatedRoleList.map(r => r.name)
      };

      console.log('更新后的账号:', accounts[accountIndex]);

      return mockDataUtil.mockRes({
        loginId: loginId,
        roleCodes: removeRoleCodeSet,
        removedRoles: roleCodes
      });
    } else {
      return apiClient.post(API_ENDPOINTS.ACCOUNT.REMOVE_ROLES, roleData);
    }
  }

  /**
   * 获取账户选项（用于下拉选择），根据操作人的当前仓进行查询
   */
  async getAccountOptions() {
    if (await apiClient.getMock() && WHOLE_USE_MOCK) {
      // 返回简化的账户信息，用于下拉选择
      const accountOptions = accounts.map(account => ({
        value: account.name,
        label: `${account.name} (${account.loginId})`,
      }));

      return mockDataUtil.mockRes(accountOptions);
    } else {
      const response = await apiClient.get(API_ENDPOINTS.AUTH.STORE_USERS);
      // 确保返回统一的数据结构
      if (response.data) {
        return {
          success: true,
          data: response.data
        };
      } else {
        return {
          success: false,
          errorMessage: 'Failed to fetch account options'
        };
      }
    }
  }
}

export const accountService = new AccountService();